import firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/firebase-auth';
import 'firebase/firebase-storage';

firebase.initializeApp({
  apiKey: "AIzaSyDRZFDLROEVwHhfSvuCqCYL6xTgtAQxoYk",
  authDomain: "mente-aberta-headshop.firebaseapp.com",
  databaseURL: "https://mente-aberta-headshop.firebaseio.com",
  projectId: "mente-aberta-headshop",
  storageBucket: "mente-aberta-headshop.appspot.com",
  messagingSenderId: "805765923072",
  appId: "1:805765923072:web:58fadbd8ade4a8279d33e5"
});

const Firestore = firebase.firestore();
const Auth = firebase.auth();
const Storage = firebase.storage();

export { Firestore, Auth, Storage };